import React from 'react';
import { useTranslation } from 'react-i18next';
import CAppSubTitle from '../../../../app/components/CAppSubTitle';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import IFund from '../../interfaces/fund/IFund';
import IFundFilters from '../../interfaces/fund/IFundFilters';
import investmentFundLang from '../../langs/investmentFundLang';
import CInvestmentFundAsset from '../../features/fund/components/CInvestmentFundAsset';
import useInvestFundAssets from '../../hooks/fund/useInvestFundAssets';
import AppLoaderContent from '../../../../app/features/loader/content/AppLoaderContent';
import { Box } from '@mui/material';

type VInvestFundAssetsListProps = {
	fund: IFund;
	filters: IFundFilters;
};

const VInvestFundAssetsList = (props: VInvestFundAssetsListProps) => {
	const { fund } = props;

	const { t } = useTranslation();

	const { fundAssets } = useInvestFundAssets(fund.id);

	return (
		<>
			<CAppSubTitle
				title={t(investmentFundLang.title_assets.tag)}
				icon={<AppCustomIcon tag="fund_assets" className="icon" />}
			/>
			<Box id="fund-assets-items">
				{fundAssets ? (
					fundAssets.map((fundAsset, index) => {
						return <CInvestmentFundAsset key={index} investmentFundAsset={fundAsset} />;
					})
				) : (
					<AppLoaderContent />
				)}
			</Box>
		</>
	);
};

export default VInvestFundAssetsList;
